import { render, staticRenderFns } from "./ConfirmRegisterUserWithEmailModal.vue?vue&type=template&id=60f847ae&scoped=true&"
import script from "./ConfirmRegisterUserWithEmailModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegisterUserWithEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRegisterUserWithEmailModal.vue?vue&type=style&index=0&id=60f847ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f847ae",
  null
  
)

export default component.exports